import { createReducer } from '@reduxjs/toolkit';

import getAcceptanceDelays from '../../../thunks/coilovers/acceptance/getAcceptanceDelays';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getAcceptanceDelaysReducer = createReducer(initialState, {
  [getAcceptanceDelays.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getAcceptanceDelays.fulfilled]: (state, {
    payload: {
      data, current_page: currentPage, last_page: lastPage, total
    }
  }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage,
    total
  }),
  [getAcceptanceDelays.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getAcceptanceDelaysReducer;
